<template>
  <div class="file-add">
    <AppFileDragDrop
      v-model="files"
      @error="showErrors"
    />

    <div class="file-add__actions">
      <v-btn
        depressed
        color="primary"
        @click="submitFiles"
      >
        Dodaj pliki
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppFileDragDrop from '@/components/UI/AppFileDragDrop.vue';

export default {
  components: {
    AppFileDragDrop,
  },

  data() {
    return {
      files: [],
    };
  },

  methods: {
    ...mapActions('files', [
      'addTempFiles',
    ]),
    ...mapActions('snackbar', [
      'showSnackbar',
    ]),

    showErrors(errors) {
      this.showSnackbar({
        message: errors,
        type: 'error',
      });
    },

    submitFiles() {
      const filesList = this.files.map((file) => (
        {
          id: file.data.lastModified + Math.random(), // Required unique ID from file timestamp
          filename: file.data.name,
          size: file.data.size,
          data: file.data,
        }
      ));
      this.addTempFiles(filesList);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-add {
  display: block;

  &__actions {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
